import { render, staticRenderFns } from "./CuponForm.vue?vue&type=template&id=37a87956&"
import script from "./CuponForm.vue?vue&type=script&lang=js&"
export * from "./CuponForm.vue?vue&type=script&lang=js&"
import style0 from "./CuponForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CuponForm.vue"
export default component.exports